var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "letter 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2 13V18.25C2 18.7141 2.19156 19.1592 2.53253 19.4874C2.87351 19.8156 3.33597 20 3.81818 20H20.1818C20.664 20 21.1265 19.8156 21.4675 19.4874C21.8084 19.1592 22 18.7141 22 18.25V13",
    stroke: "#5283EC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22 8.54545V5.81818C22 5.33597 21.8084 4.87351 21.4675 4.53253C21.1265 4.19156 20.664 4 20.1818 4H3.81818C3.33597 4 2.87351 4.19156 2.53253 4.53253C2.19156 4.87351 2 5.33597 2 5.81818V8.54545L12 14L22 8.54545Z",
    stroke: "#5283EC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.2a05f5b5a9bd5299d5365c5b60be1971.svg";
export { ForwardRef as ReactComponent };